import * as React from 'react';

import {PopoverInfo} from 'shells/popover-info/popover-info';
import {LegacySetupTableContainer} from 'shells/table/legacy-setup-table-container';
import {LegacySetupTableWrapper} from 'shells/table/legacy-setup-table-wrapper';
import {Table} from 'shells/table/table';
import {Body} from 'shells/typography/body';

import type {GetWorkOsInformation_workOs_domainInfo as DomainInfo} from 'nutshell-graphql-types';

import {getIconStatus} from './helpers';

type Props = {
    domainInfo: DomainInfo;
    actionItem?: React.ReactNode;
};

export function DomainsTable(props: Props) {
    const columns = React.useMemo(
        () => [
            {
                id: 'name',
                Header: 'Domain',
                // @ts-expect-error
                accessor: (row) => row.domain,
                dataType: 'component',
                width: 200,
                Cell: ({cell}: any) => (
                    <div title={cell.value} className='truncate'>
                        {cell.value}
                    </div>
                ),
            },
            {
                id: 'ssoStatus',
                Header: 'Available for SSO',
                // @ts-expect-error
                accessor: (row) => getIconStatus(row.isVerified, 'sso'),
                dataType: 'iconStatus',
                width: 200,
            },
            {
                id: 'pinnedStatus',
                Header: () => {
                    return (
                        <div className='flex'>
                            Pinned status
                            <PopoverInfo
                                size={16}
                                info='Whether this domain is locked to your Nutshell account, allowing you to instantly provision users in Nutshell that are part of your external identity provider. For additional help, contact support.'
                            />
                        </div>
                    );
                },
                // @ts-expect-error
                accessor: (row) => getIconStatus(row.isMarkedAsPinned, 'pinned'),
                dataType: 'iconStatus',
            },
        ],
        []
    );

    return (
        <LegacySetupTableWrapper
            title='Domains'
            count={props.domainInfo.domains.length}
            actionItem={props.actionItem}
            fullWidth={true}
        >
            <LegacySetupTableContainer>
                <Table
                    // @ts-expect-error
                    columns={columns}
                    data={props.domainInfo.domains}
                    disableSorting={true}
                    disableFilters={true}
                    fullWidth={true}
                    specialStates={[
                        {
                            shouldRender: () => Boolean(props.domainInfo.domains.length === 0),
                            component: renderEmptyState(),
                        },
                    ]}
                />
            </LegacySetupTableContainer>
        </LegacySetupTableWrapper>
    );
}

const renderEmptyState = () => {
    return (
        <div className='pad-8'>
            <Body size='small'>No domains</Body>
        </div>
    );
};
